import React from 'react';

const CaseSummarizer = () => {
  return (
    <div className="p-4 border rounded-lg shadow-sm bg-white dark:bg-gray-800">
      <h2 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">Case Summarizer & Gap Finder</h2>
      <p className="text-gray-600 dark:text-gray-300">
        Upload or paste raw case materials (reports, witness statements, evidence logs) to generate a clean, hyperlinked summary. The AI will also identify gaps, inconsistencies, and contradictions.
      </p>
      <div className="mt-4">
        <textarea
          className="w-full p-2 border rounded-md bg-gray-50 dark:bg-gray-700 dark:text-gray-200"
          rows="5"
          placeholder="Paste case files here..."
        ></textarea>
        <button className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700">
          Analyze
        </button>
      </div>
    </div>
  );
};

export default CaseSummarizer;